import { queryOptions } from '@tanstack/react-query';

import type { GetProductsBySearchBoosterQueryVariables } from '@schema/cart';

import API from '@api';

/**
 * Результаты поиска кэшируем ненадолго: повторный ввод того же текста
 * и переход из саджеста шапки на страницу выдачи с теми же параметрами
 * идут из кэша без лишних запросов.
 */
const SEARCH_STALE_TIME = 5 * 60 * 1000;
const SEARCH_GC_TIME = 10 * 60 * 1000;

export const productsBySearchBoosterQueryOptions = (
  params: GetProductsBySearchBoosterQueryVariables = {}
) =>
  queryOptions({
    queryKey: ['productsBySearchBooster', params],
    queryFn: () => API.getProductsBySearchBooster(params),
    staleTime: SEARCH_STALE_TIME,
    gcTime: SEARCH_GC_TIME
  });

export const SEARCH_QUERIES_QUERY_KEY = 'peopleSearchQueries';

/**
 * История поисковых запросов пользователя (саджест в шапке).
 * staleTime 0: каждый фокус на поле рефетчит список — новые запросы
 * попадают в историю сразу, как в старой реализации.
 */
export const peopleSearchQueriesQueryOptions = () =>
  queryOptions({
    queryKey: [SEARCH_QUERIES_QUERY_KEY],
    queryFn: () =>
      API.getPeopleSearchQueries().then(res => res.getPeopleSearchQueries ?? [])
  });

/** Примеры запросов для плейсхолдера «например, …» */
export const searchExampleQueryOptions = () =>
  queryOptions({
    queryKey: ['searchExample'],
    queryFn: () =>
      API.getSearchExample().then(
        res => res.getSearchExample?.searchExamples ?? []
      ),
    staleTime: SEARCH_STALE_TIME,
    gcTime: SEARCH_GC_TIME
  });

// module-level: стабильная ссылка для select
const selectPopularQueriesAndCategories = (
  res: Awaited<ReturnType<typeof API.getPopularQueriesAndCategories>>
) => ({
  queries:
    res?.getPopularQueriesAndCategories?.queries
      ?.reduce((acc: string[], item) => {
        if (item.query) return [...acc, item.query];
        return acc;
      }, [])
      ?.slice(0, 8) || ['Красная икра'],
  categories: (
    res?.getPopularQueriesAndCategories?.categories?.filter(
      item => !!item.category && !!item.identify && !!item.title
    ) || []
  ).slice(0, 8)
});

/** Популярные запросы и рубрики (нулевая выдача поиска) */
export const popularQueriesAndCategoriesQueryOptions = () =>
  queryOptions({
    queryKey: ['popularQueriesAndCategories'],
    queryFn: () => API.getPopularQueriesAndCategories(),
    select: selectPopularQueriesAndCategories,
    staleTime: SEARCH_STALE_TIME,
    gcTime: SEARCH_GC_TIME
  });
